<h1 mat-dialog-title>
    <span>{{ data?.title || ('pleaseWait.title' | translate) }}</span>
</h1>
<div mat-dialog-content class="d-flex align-items-center">
    <mat-spinner diameter="50"></mat-spinner>

    <ng-container *ngIf="(data?.progression | async) as prog; else tplDefault">
        <strong class="p-t-10" [translate]="!prog.etape ? 'liste.loading' : ('progression.etape.' + prog.etape)"></strong>
        <mat-progress-bar
                class="statut-bar mt-3"
                mode="buffer"
                [bufferValue]="0"
                [value]="prog.progression">
        </mat-progress-bar>
        <div class="text-center">{{ prog.nbTraites }} / {{ prog.nbTotal }}</div>
    </ng-container>

    <ng-template #tplDefault>
        <strong class="p-t-10" [translate]="'liste.loading'"></strong>
        <span [translate]="'liste.pleaseWait'"></span>
    </ng-template>
</div>